export default "__VITE_ASSET__D$McaIGr__"